export default class Human {

    constructor(p, x, y, r, width, height, infectionRate, infectionDuration, morality) {
        this.state = 0;
        this.width = width;
        this.height = height;
        this.p = p;
        this.r = r;
        this.morality = morality;
        this.infectionDuration = infectionDuration;
        this.infectionRate = infectionRate;
        this.position = p.createVector(x, y);
        this.framesTillHealed = 55 * this.infectionDuration;

        this.touchedWallX = 0;
        this.touchedWallY = 0;
    }

    update() {
        if (this.state !== 3) {
            if (this.state === 1) {
                this.framesTillHealed--;
            }
            if (this.framesTillHealed < 0 && this.state !== 2) {
                if (Math.random() < this.morality) {
                    this.state = 3;
                }
                else { this.state = 2; }
            }

            this.position.add(this.velocity);

            if (this.touchedWallX <= 0 && (this.position.x - this.r < this.r || this.position.x > this.width - this.r)) {
                this.velocity.x *= -1;
                this.touchedWallX = 10;
            } else {
                this.touchedWallX--;
            }

            if (this.touchedWallY <= 0 && (this.position.y <= this.r || this.position.y >= this.height - this.r)) {
                this.velocity.y *= -1;
                this.touchedWallY = 10;
            } else {
                this.touchedWallY--;
            }
        }
    }

    show() {
        let radius = this.r;
        if (this.state === 0) {
            this.p.fill('#fff');
            this.p.stroke('#000')
            radius -= 1;
        } else if (this.state === 1) {
            this.p.fill('#6CB4EE');
            this.p.stroke('#0000')
        }
        else if (this.state === 2) {
            this.p.fill('#4F7942');
            this.p.stroke('#0000')
        } else if (this.state === 3) {
            this.p.fill(0);
            this.p.stroke('#0000')
        }
        this.p.ellipse(this.position.x, this.position.y, radius * 2);
    }

    showFill(fill) {
        this.p.fill(fill);
        this.p.ellipse(this.position.x, this.position.y, this.r * 2);
    }

    turn(otherHuman) {
        let xDif = this.position.copy().add(this.velocity).x - otherHuman.position.copy().add(otherHuman.velocity).x;
        let yDif = this.position.copy().add(this.velocity).y - otherHuman.position.copy().add(otherHuman.velocity).y;

        let difference = this.p.createVector(xDif, yDif);
        difference.normalize();

        this.velocity.add(difference);
        this.velocity.normalize();
        this.velocity.x *= this.speed;
        this.velocity.y *= this.speed;

        otherHuman.velocity.sub(difference);
        otherHuman.velocity.normalize();
        otherHuman.velocity.x *= otherHuman.speed;
        otherHuman.velocity.y *= otherHuman.speed;

        if (this.state === 1 && otherHuman.state === 0) {
            if (Math.random() < this.infectionRate) {
                otherHuman.state = 1;
            }
        } else if (otherHuman.state === 1 && this.state === 0) {
            if (Math.random() < this.infectionRate) {
                this.state = 1;
            }
        }
    }

    setSpeed(speed) {
        this.speed = speed;
        this.velocity = this.p.createVector((Math.random() * 2) - 1, (Math.random() * 2) - 1);
        this.velocity.normalize();
        this.velocity.x *= speed;
        this.velocity.y *= speed;
    }
}